'use client';

import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { ChatWindow } from './chat-window';

/**
 * Floating chat widget — bottom-right en desktop, bottom-center en mobile.
 * Se monta en RootLayout, pero solo renderiza el botón cuando el user
 * interactúa (no autoabrir respetando consent minimalism).
 */
export function ChatWidget() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Abrir chat de ayuda"
          className="fixed right-4 bottom-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-accent)] text-[var(--color-accent-fg)] shadow-[0_8px_24px_rgba(201,166,107,0.3)] hover:bg-[var(--color-accent)] md:right-6 md:bottom-6"
        >
          <MessageCircle className="h-6 w-6" strokeWidth={1.5} />
        </button>
      ) : null}

      {open ? (
        <div
          role="dialog"
          aria-modal="false"
          aria-label="Chat con asistente NQORO"
          className="fixed right-0 bottom-0 z-40 h-[85vh] w-full overflow-hidden border border-[var(--color-border)] bg-[var(--color-bg)] shadow-2xl md:right-6 md:bottom-6 md:h-[600px] md:w-[400px] md:rounded-sm"
        >
          <ChatWindow onClose={() => setOpen(false)} source="widget" />
        </div>
      ) : null}
    </>
  );
}
